import { API_USER_URL } from "@/env";

async function updateUserRole(userId: string, role: string) {
    const response = await fetch(`${API_USER_URL}/api/v1/be/users/${userId}/assign-roles`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
        },
        body: JSON.stringify({ 
            roles: [role]
         }),
    });
    return response.json();
}

export { updateUserRole };